import { BaseModel } from "../../../ensue-react-system/utilities/base-model";
import { IFootballOrganizer } from "./interface/i-football-organizer";

export class FootballOrganizer extends BaseModel implements IFootballOrganizer {
  public id: number = 0;
  public name: string = "";
  public country: string = "";
  public logo: string = "";
  public email: string = "";
  public website: string = "";

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
